<template>
  <button
      :type="type ? type : ''"
      class="button"
      :disabled="isDisabled"
      :class="[{active: isLoading}]"
  >
    <ui-loader class="button__loader" v-if="isLoading" />
    <slot v-else />
  </button>
</template>

<script setup>
import UiLoader from "@/components/ui/ui-loader.vue";

const props = defineProps({
  isDisabled: Boolean,
  isLoading: Boolean,
  type: String
})
</script>

<style lang="scss" scoped>
.button {
  cursor: pointer;
  width: 100%;
  padding-block: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  border-radius: 10px;
  border: 2px solid $white;
  box-shadow: 0 0 40px 0 rgba(255, 255, 255, 0.46), 1px 1px 6px 0 #FFF, 0 0 6px 2px #FFF inset;
  background-color: transparent;
  transition: 0.2s;

  text-shadow: 0 0 10px $white;
  color: $white;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 1px;

  @include hover {
    background-color: $white;
    color: $black;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    @include hover {
      background-color: transparent;
      color: $white;
    }
  }

  &__loader {
    margin-block: 7px;
  }
}
</style>